import {AttributeConsistencyStatus} from '@frontend/shared-api';

export const ATTRIBUTE_CONSISTENCY_STATUS_LABEL_KEYS: Record<AttributeConsistencyStatus, string> = {
  [AttributeConsistencyStatus.ACCEPTED]: 'evaluation.consistency.status.accepted',
  [AttributeConsistencyStatus.REVIEW_REQUIRED]: 'evaluation.consistency.status.reviewRequired',
  [AttributeConsistencyStatus.MANUALLY_ACCEPTED]: 'evaluation.consistency.status.manuallyAccepted',
  [AttributeConsistencyStatus.CLARIFICATION_REQUIRED]:
    'evaluation.consistency.status.clarificationRequired',
};

export const ATTRIBUTE_CONSISTENCY_STATUS_COLORS: Record<AttributeConsistencyStatus, string> = {
  [AttributeConsistencyStatus.ACCEPTED]: '#22c55e',
  [AttributeConsistencyStatus.REVIEW_REQUIRED]: '#f5b400',
  [AttributeConsistencyStatus.MANUALLY_ACCEPTED]: '#22c55e',
  [AttributeConsistencyStatus.CLARIFICATION_REQUIRED]: '#e54d5b',
};
